import React, { useEffect } from 'react';
import cn from 'classnames';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import compact from 'lodash/compact';

import Icon from '../../../../Icon';
import { PROVIDER_OPTION } from '../../constants';
import { useChartContext } from '../../hooks';
import styles from './styles.styl';

const {
  ICON,
  ACTIVE_ICON,
  DISABLED_ICON,
  SINGLE_VALUE_ICON,
  ACTIVE_SINGLE_VALUE_ICON,
} = PROVIDER_OPTION;

const ChartLegend = ({ config, loading, isQuarterOrYear }) => {
  const {
    chart,
    sources,
    formats,
    activeSource,
    setActiveSource,
  } = useChartContext();

  useEffect(() => {
    setActiveSource(sources.length > 1 ? null : sources[0]);
  }, [config, sources]);

  const datasets = get(config, 'data.datasets', []);

  const existsSource = source =>
    datasets.some(({ label }) => label.startsWith(source));

  const getIsSingleValue = source =>
    datasets.some(
      ({ label, data }) =>
        label.startsWith(source) && compact(data).length === 1,
    );

  const toggleSource = source => {
    if (sources.length === 1) return;

    datasets.forEach(({ label }, idx) => {
      const meta = chart.getDatasetMeta(idx);

      meta.hidden = source === activeSource ? false : !label.startsWith(source);
      setActiveSource(source === activeSource ? null : source);

      chart.update();
    });
  };

  const getIconName = ({ provider, isActive, isDisabled, isSingleValue }) => {
    const {
      [ICON]: icon,
      [ACTIVE_ICON]: activeIcon,
      [DISABLED_ICON]: disabledIcon,
      [SINGLE_VALUE_ICON]: singleValueIcon,
      [ACTIVE_SINGLE_VALUE_ICON]: activeSingleIcon,
    } = provider;

    if (isDisabled) return disabledIcon || icon;
    if (isActive && !isSingleValue) return activeIcon || icon;
    if (isActive && isSingleValue) return activeSingleIcon || icon;
    return isSingleValue && singleValueIcon ? singleValueIcon : icon;
  };

  return (
    <div className={styles.legend}>
      {!loading &&
        datasets.length > 0 &&
        Object.entries(config.data.customOptions.providers).map(
          ([providerCode, provider]) => {
            const isActive = providerCode === activeSource;
            const isDisabled = !existsSource(providerCode);
            const isSingleValue =
              isQuarterOrYear && !isDisabled && getIsSingleValue(providerCode);
            const iconName = getIconName({
              provider,
              isActive,
              isDisabled,
              isSingleValue,
            });

            return (
              <div
                aria-hidden
                key={providerCode}
                onClick={() => toggleSource(providerCode)}
                className={cn(styles.item, {
                  [styles.active]: isActive,
                  [styles.disabled]: isDisabled,
                  [styles.noclick]: providerCode.length === 1,
                })}
              >
                <Icon size={24} className="mr2" name={iconName} />
                {formats[providerCode]}
              </div>
            );
          },
        )}
    </div>
  );
};

ChartLegend.propTypes = {
  loading: PropTypes.bool,
  config: PropTypes.object,
  isQuarterOrYear: PropTypes.bool,
};

export default ChartLegend;



// WEBPACK FOOTER //
// ./src/components/common/Charts/ChartWrapper/ChartLegend/index.jsx